<template>
  <v-container fluid>
    <v-row class="mx-0 mx-md-10 my-0 my-md-8">
      <v-col cols="12" md="6">
        <h2>Cansado de correr atrás de pacientes para lotar sua clínica?</h2>
        <p class="subtitle mb-4">Conte com a <strong>Agência 352</strong> para lotar seu consultório <strong>TODO DIA!</strong></p>
        <v-row class="my-12">
          <v-col cols="12" md="6" class="py-0 my-0">
            <p><v-icon color="primary">mdi-check</v-icon>Gestão de Mídias Sociais</p>
            <p><v-icon color="primary">mdi-check</v-icon>Desenvolvimento de Websites</p>
            <p><v-icon color="primary">mdi-check</v-icon>Gestão de Campanhas em plataformas de anúncios</p>
          </v-col>
          <v-col cols="12" md="6" class="py-0 my-0">
            <p><v-icon color="primary">mdi-check</v-icon>Campanhas de E-mail Marketing</p>
            <p><v-icon color="primary">mdi-check</v-icon>Edição de Vídeos Promocionais</p>
            <p><v-icon color="primary">mdi-check</v-icon>e muito mais...</p>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="4" class="px-0 px-md-4">
        <v-card>
          <v-card-text>
            <h4><strong>O primeiro passo</strong></h4>
            <p>Preencha o formulário abaixo e dê o primeiro passo em direção ao sucesso:</p>
            <v-form>
              <v-text-field
                outlined
                v-model="name"
                label="Nome"
                prepend-inner-icon="mdi-account-circle"
              ></v-text-field>
              <v-text-field
                outlined
                v-model="email"
                label="Email"
                prepend-inner-icon="mdi-mail"
                :rules="[rules.email]"
              ></v-text-field>
              <v-text-field
                outlined
                v-model="phone"
                label="Telefone"
                prepend-inner-icon="mdi-phone"
                @keypress="checkPhone()"
              ></v-text-field>

              <v-btn
                block
                color="primary"
                depressed
                x-large
                @click="submit()"
              >Confirmar</v-btn>
            </v-form>
          </v-card-text>

        </v-card>
      </v-col>
    </v-row>
    <v-row class="mx-0 mx-md-10">
      <v-col cols="12">
        <h3>Fale conosco</h3>
        <p>Entre em contato conosco e utilize o código <strong>#352MED</strong> para ganhar um desconto no seu pacote!</p>
        <v-row>
          <v-col cols="2" md="1">
            <v-btn
              depressed
              x-large
              color="transparent"
              fab
              class="mr-8"
              href="tel:(21)97917-5520"
            >
              <v-icon>mdi-phone</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="2" md="1">
            <v-btn
              depressed
              x-large
              color="transparent"
              fab
              class="mr-8"
              href="https://wa.me/5521979175520"
              target="_blank"
            >
              <v-icon>mdi-whatsapp</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="2" md="1">
            <v-btn
              depressed
              x-large
              color="transparent"
              fab
              class="mr-8"
              href="https://www.linkedin.com/company/10549379"
              target="_blank"
            >
              <v-icon>mdi-linkedin</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="2" md="1">
            <v-btn
              depressed
              x-large
              color="transparent"
              fab
              class="mr-8"
              href="https://www.messenger.com/t/ag352"
              target="_blank"
            >
              <v-icon>mdi-facebook-messenger</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="2" md="1">
            <v-btn
              depressed
              x-large
              color="transparent"
              fab
              class="mr-8"
              href="https://www.instagram.com/352agencia"
              target="_blank"
            >
              <v-icon>mdi-instagram</v-icon>
            </v-btn>
          </v-col>
        </v-row>






      </v-col>
    </v-row>
    <v-snackbar color="red" class="black--text darken-3" v-model="alert">
      {{ this.feedback }}
      <v-btn color="white" text @click="alert = false" >
        Ok
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import db from '@/firebase/init'
  export default {
    name: 'HelloWorld',

    data(){
      return {
        name: null,
        email: null,
        phone: null,
        alert: false,
        feedback: null,
        rules: {
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'E-mail inválido.'
          },
        },
      }
    },
    methods: {
      submit(){

        if(this.name && this.email && this.phone){
          window.console.log(this.name, this.email, this.phone)
          let lead = {
            nome: this.name,
            email: this.email,
            tel: this.phone
          }
          db.collection('lp-mm').add(lead)
          .then(() => {
            this.name = ""
            this.email = ""
            this.phone = ""
          })
          .catch(e => {
            window.console.log(e.message)
          })
        }else{
          this.alert = true
          this.feedback = 'Todos os campos devem ser preenchidos'
        }
      },
      oi(){
        window.console.log('oi')
      },
      checkPhone(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
          // console.log(charCode)
          this.alert = true
          this.feedback = 'Este campo só aceita números, . ou -'
          evt.preventDefault();
        } else {
          // console.log('é numero')
          // console.log(charCode)
          this.alert = false
          return true
        }
      }
    }
  }
</script>

<style lang="scss">
  h2{
    font-size: 3em;
  }
  h3{
    font-size: 2em;
  }
  h4{
    font-size: 1.3em
  }
  .subtitle{
    font-size: 1.4em;
  }
  p{
    font-size: 1.1em;
    .v-icon{
      margin-right: 10px;
    }
  }
  @media only screen and (max-width: 600px){
    h2{
      font-size: 2.1em;
    }
    .subtitle{
      font-size: 1.2em;
    }
  }
</style>
